<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="#ECEFF1" />
    <g opacity="0.4" clip-path="url(#clip0_2271_54395)">
      <path
        d="M8.55283 7.6945C10.065 6.38422 11.9995 5.66421 14.0003 5.667C18.6028 5.667 22.3337 9.39783 22.3337 14.0003C22.3337 15.7803 21.7753 17.4303 20.8253 18.7837L18.167 14.0003H20.667C20.6671 12.6934 20.283 11.4152 19.5625 10.3247C18.8421 9.23426 17.8169 8.37963 16.6146 7.8671C15.4123 7.35457 14.0859 7.20675 12.8003 7.44202C11.5147 7.67728 10.3265 8.28525 9.38366 9.19033L8.55283 7.6945ZM19.4478 20.3062C17.9357 21.6165 16.0012 22.3365 14.0003 22.3337C9.39783 22.3337 5.66699 18.6028 5.66699 14.0003C5.66699 12.2203 6.22533 10.5703 7.17533 9.217L9.83366 14.0003H7.33366C7.33355 15.3073 7.71762 16.5855 8.43811 17.676C9.15859 18.7664 10.1837 19.621 11.386 20.1336C12.5883 20.6461 13.9147 20.7939 15.2004 20.5587C16.486 20.3234 17.6741 19.7154 18.617 18.8103L19.4478 20.3062Z"
        fill="#263238" />
    </g>
    <defs>
      <clipPath id="clip0_2271_54395">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>